import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_projectsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectIds?: number[], ownerIds?: number[] }): 
  Promise<{ result: { Id?: number, IsDefault?: boolean, Name?: string, StatusId?: number, Owner?: { Id?: number, Name?: string, StatusId?: number } }[] }> 
  {
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_projects/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectIds?: number[], ownerIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, IsDefault?: boolean, Name?: string, StatusId?: number, Owner?: { Id?: number, Name?: string, StatusId?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_projects/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectIds?: number[], ownerIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, IsDefault?: boolean, Name?: string, StatusId?: number, Owner?: { Id?: number, Name?: string, StatusId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_projects/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectIds?: number[], ownerIds?: number[]    }) {
      return false;
    }
}
